import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[640px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20composition%20with%20warm%20golden%20amber%20and%20cream%20tones%2C%20soft%20gradient%20layers%2C%20minimalist%20tech%20aesthetic%2C%20smooth%20flowing%20shapes%2C%20elegant%20and%20modern%20atmosphere%2C%20subtle%20light%20patterns%2C%20calm%20and%20professional%20background%2C%20no%20text%2C%20abstract%20digital%20texture&width=1800&height=1200&seq=hero-17c-bg&orientation=landscape"
          alt="17c 平台背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-16 md:py-20">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-8">
          <i className="ri-sparkling-line text-primary-300 text-sm"></i>
          <span className="text-sm text-background-100">http //www.17c/ 官方入口</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-6">
          17c 平台
          <span className="block text-primary-300 mt-2">您的数字化服务专家</span>
        </h1>

        <p className="text-base md:text-lg text-background-200/80 max-w-2xl mx-auto mb-10 leading-relaxed">
          提供完整的访问指引、功能介绍与使用说明，帮助您快速找到 http //www.17c/ 的正确入口，了解平台核心功能、注册流程及常见问题解答，让您的访问体验更顺畅高效。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/guide"
            className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-primary-500 text-background-50 font-medium text-base hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap text-center"
          >
            访问指南
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/category/features"
            className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-background-50/15 backdrop-blur-sm text-background-100 font-medium text-base border border-background-50/30 hover:bg-background-50/25 transition-all duration-200 cursor-pointer whitespace-nowrap text-center"
          >
            探索功能
            <i className="ri-apps-line ml-2"></i>
          </Link>
        </div>

        <div className="mt-12 flex items-center justify-center gap-8 flex-wrap">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">500K+</div>
            <div className="text-xs text-background-300/80 mt-1">服务用户</div>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">30+</div>
            <div className="text-xs text-background-300/80 mt-1">功能模块</div>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">5年+</div>
            <div className="text-xs text-background-300/80 mt-1">稳定运营</div>
          </div>
        </div>
      </div>
    </section>
  );
}